var PositionHelper = /** @class */ (function () {
    function PositionHelper() {
    }
    /**
     * Ensures that a popup element is positioned so that it remains in the bounds of the screen by left/right/top/bottom aligning it relative to the anchor element.
     * @param trigger The element to which the popup is anchored
     * @param popup The element which pops up from the anchor.
     * @param fromBottom True if the popups bottom style property must be set. Set to false if there are buttons at the top of the popup and the popups height may change.
     * @param alignRight True if the popup must be aligned to the anchors right position.
     */
    PositionHelper.checkScreenBounds = function (anchor, popup, fromBottom, alignRight) {
        if (fromBottom === void 0) { fromBottom = true; }
        if (alignRight === void 0) { alignRight = false; }
        var popupHeight = popup.offsetHeight;
        var containerScreenRect = anchor.getBoundingClientRect();
        if (containerScreenRect.bottom + anchor.offsetHeight + popupHeight > window.innerHeight - 20 && containerScreenRect.top > popupHeight) {
            if (fromBottom) {
                popup.style.top = "auto";
                popup.style.bottom = "100%";
            }
            else {
                popup.style.bottom = "";
                popup.style.top = -(popupHeight) + "px";
            }
        }
        else {
            popup.style.top = "100%";
            popup.style.bottom = "auto";
        }
        var popupWidth = popup.offsetWidth;
        if ((!alignRight && containerScreenRect.left + popupWidth > window.innerWidth - 20) ||
            (alignRight && containerScreenRect.right - popupWidth >= 0)) {
            popup.style.left = "auto";
            popup.style.right = "0";
        }
        else {
            popup.style.left = "0";
            popup.style.right = "auto";
        }
    };
    return PositionHelper;
}());
export default PositionHelper;
